import PropTypes from "prop-types";

import { ComboboxItem } from "@/components/ui/combobox";

import TagBadge from "./TagBadge";

const CatalogTagItem = ({ tag }) => (
  <ComboboxItem
    value={tag.id}
    disabled={!tag.enabled}
    className="tw:cursor-pointer"
  >
    <TagBadge tag={tag} />
  </ComboboxItem>
);

CatalogTagItem.propTypes = {
  tag: PropTypes.object.isRequired,
};

export default CatalogTagItem;
